import { useState } from 'react'
import { Separator } from '@/components/ui/separator'
import { Header } from '@/components/layout/Header'
import { Footer } from '@/components/layout/Footer'
import { Hero } from '@/components/sections/Hero'
import { FeatureSections } from '@/components/sections/FeatureSections'
import { WaitlistFormSection } from '@/components/sections/WaitlistForm'
import { navLinks } from '@/data/nav-links'

const scrollToSection = (id: string) => {
  const element = document.getElementById(id)
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
}

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

const App = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  const handleNavClick = (id: string) => {
    scrollToSection(id)
    setMobileMenuOpen(false)
  }

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header
        navLinks={navLinks}
        mobileMenuOpen={mobileMenuOpen}
        onMobileMenuChange={setMobileMenuOpen}
        onNavClick={handleNavClick}
        onLogoClick={scrollToTop}
      />

      {/* Main Content */}
      <main>
        <Hero onCTAClick={() => scrollToSection('contact')} />

        <Separator />

        {/* Content Container */}
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 max-w-7xl">
          <FeatureSections />
          <WaitlistFormSection />
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default App
